import { gql, graphql } from "react-apollo"
import { GetKiosksQuery } from "./withKiosks"
import type { OperationComponent, QueryProps, NamedProps } from "react-apollo"

const MUTATE_DELETE_KIOSK = gql`
  mutation DeleteKiosk($id: ID!) {
    deleteKiosk(id: $id) {
      id
    }
  }
`

type Response = {
  deleteKiosk: {
    id: string
  }
}

type Props = QueryProps & Response

type MappedProps = NamedProps<{ mutateDeleteKiosk: Props }>

const mutateDeleteKiosk: OperationComponent<
  Response,
  Props
> = graphql(MUTATE_DELETE_KIOSK, {
  name: "mutateDeleteKiosk",
  options: {
    refetchQueries: [{ query: GetKiosksQuery, variables: { query: "" } }]
  },
  props: ({ mutateDeleteKiosk }: MappedProps) => ({
    deleteKiosk: (id: string) =>
      mutateDeleteKiosk({
        variables: { id: id }
      })
  })
})

export default mutateDeleteKiosk



// WEBPACK FOOTER //
// ./src/Kiosks/queries/mutateDeleteKiosk.js